<script>
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';
import UiHeadline from '../ui/Headline';
import UiSubheader from '../ui/Subheader';
import UiStepper from '../ui/Stepper';
import UiLoading from '../ui/Loading';
import UiScrollbar from '../ui/Scrollbar';
import deepEqual from 'deep-equal';

export default {
    mixins: [store],
    props: {
        value: Object,
        setStep: Function,
    },
    components: {
        UiHeadline,
        UiSubheader,
        UiLoading,
        UiScrollbar,
    },
    data: () => ({
        data: null,
        bubbles: [],
        bubblesLoading: false,
        uploading: false,
        uploadError: false,
        uploadDuplicateFilename: false,
    }),
    computed: {
        bubblesSorted() {
            return this.bubbles === null ? [] : this.bubbles.sort((a, b) => b.id - a.id);
        },
    },
    created() {
        this.data = Object.assign({}, this.value);
        this.fetchBubbles();
    },
    methods: {
        fetchBubbles(selectByFilename = false) {
            this.bubblesLoading = true;
            sdk.pressengerControl.getSenderGroupId().then(sgid => {
                sdk.pressengerControl.getNotificationLogos(sgid).then(bubbles => {
                    this.bubbles = bubbles;
                    this.bubblesLoading = false;
                    this.bubbles.forEach(i => {
                        if (selectByFilename) {
                            if (i.fileName === selectByFilename) {
                                this.data.bubble = i;
                            }
                        } else if (i.fileName === this.userInfo.defaultLogo) {
                            //this.data.bubble = i;
                        }
                    });
                }).catch(() => {
                    setTimeout(() => {
                        this.fetchBubbles();
                    }, 1000);
                });
            }).catch(() => {
                setTimeout(() => {
                    this.fetchBubbles();
                }, 1000);
            });
        },
        getBubbleImage(bubble) {
            return sdk.getBubbleImage(bubble.groupId, bubble.fileName);
        },
        selectBubble(bubble) {
            if (!bubble || this.data.bubble === bubble) {
                this.data.bubble = false;
                if (this.userInfo.secondLogoEnabled) {
                    this.setStep(7, false);
                }
            } else {
                this.data.bubble = bubble;
                if (this.userInfo.secondLogoEnabled) {
                    const disableRich = ['gif', 'mp4'].includes(this.getBubbleImage(bubble).split('.').pop().toLowerCase());
                    this.setStep(7, disableRich);
                }
            }
        },
        onPrevClicked() {
            if (this.bubblesLoading || !this.bubblesSorted.length) {
                return;
            }
            if (!this.data.bubble) {
                this.data.bubble = this.bubblesSorted[0];
                return;
            }
            let index = 0;
            this.bubblesSorted.forEach((b, i) => {
                if (b === this.data.bubble) {
                    index = i;
                }
            });
            index--;
            if (index < 0) {
                index = this.bubblesSorted.length - 1;
            }
            this.data.bubble = this.bubblesSorted[index];
        },
        onNextClicked() {
            if (this.bubblesLoading || !this.bubblesSorted.length) {
                return;
            }
            if (!this.data.bubble) {
                this.data.bubble = this.bubblesSorted[0];
                return;
            }
            let index = 0;
            this.bubblesSorted.forEach((b, i) => {
                if (b === this.data.bubble) {
                    index = i;
                }
            });
            index++;
            if (index >= this.bubblesSorted.length) {
                index = 0;
            }
            this.data.bubble = this.bubblesSorted[index];
        },
        upload() {
            this.uploadError = false;
            this.uploadDuplicateFilename = false;
            const files = event.target.files || event.dataTransfer.files;
            if (!files || !files[0]) {
                return;
            }
            if (this.checkIsDuplicateFilename(files[0].name.replace(/[^\w.-]+/g, '_'))) {
                this.uploadError = true;
                this.uploadDuplicateFilename = true;
                return;
            }
            const image = new File([files[0]], `${Date.now()}-${files[0].name.replace(/[^\w.-]+/g, '_')}`)
            this.uploading = true;
            sdk.pressengerControl.uploadNotificationLogo(image).then(uploaded => {
                // TODO: null returned on upload
               this.fetchBubbles(image.name.replace(/[^\w.-]+/g, '_'));
            }).catch(() => {
                this.uploadError = true;
            }).finally(() => {
                this.uploading = false;
            });
        },
        friendlyName(filename, trimExt = true) {
            let name = filename;
            const prefix = name.match(/^[0-9]+-/gi);
            const ext = name.match(/.[a-z]+$/gi);
            if (prefix) {
                name = name.substring(prefix[0].length);
            }
            if (trimExt, ext) {
                name = name.substring(0, name.length - ext[0].length)
            }
            return name;
        },
        checkIsDuplicateFilename(filename) {
            const ffn = this.friendlyName(filename)
            return !!this.bubbles.find(i => this.friendlyName(i.fileName) === ffn);
        },
        showHint() {
            this.data.hint = this.$t('sendPressageView.NoBubbleHint');
        },
        hideHint() {
            this.data.hint = false;
        },
    },
    watch: {
        value: {
            deep: true,
            handler(nextVal) {
                if (!deepEqual(nextVal, this.data)) {
                    this.data = Object.assign({}, nextVal);
                }
            }
        },
        data: {
            deep: true,
            handler: function(nextVal) {
                if (!deepEqual(nextVal, this.value)) {
                    this.$emit('input', Object.assign({}, nextVal));
                }
            }
        },
    },
}
</script>

<template>
    <div class="StepBubbles">
        <!--
        <ui-subheader>{{ $t('stepBubbles.step') }} 2<span>/5</span></ui-subheader>
        <ui-headline>{{ $t('stepBubbles.title') }}</ui-headline>
        -->
        <ui-loading v-if="bubblesLoading || uploading" />
        <template v-else>
            <div class="Grid" style="padding-right: 20px; margin-bottom: 50px;">
                <div :class="['GridItem', 'UploadButton', 'DisableHover', {Error: uploadError}]" @click="$refs.uploader.click()" v-if="!isUploadDisabled">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper">
                        <span class="GridItemErrorMessage" v-if="uploadDuplicateFilename">{{ $t('sendPressageView.uploadErrorDuplicateFilename') }}</span>
                    </div>
                    <div class="GridItemHint" v-html="$t('sendPressageView.stepAndroidBubblesUploadHint')" />
                </div>
                <div :class="['GridItem', 'NoneButton', 'NoBorderLeft', 'DisableHover', {Active: !data.bubble}]" @click="selectBubble(null)" @mouseenter="showHint()" @mouseleave="hideHint()">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper"></div>
                    <div class="Check">
                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="16.5" height="13.5" viewBox="0 0 16.5 13.5" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.038 2.741c.298-.305.462-.708.462-1.133 0-.43-.164-.833-.462-1.138a1.55 1.55 0 00-2.222 0L4.869 9.616 2.684 7.385a1.548 1.548 0 00-2.222 0A1.614 1.614 0 000 8.522c0 .429.164.832.462 1.133l3.293 3.365a1.55 1.55 0 002.222 0"/></svg>
                    </div>
                    <div class="GridItemHint" v-html="$t('sendPressageView.stepAndroidBubblesXHint')" />
                </div>
            </div>
            <ui-scrollbar :height="220">
                <div class="Grid">
                    <div
                        v-for="(i, index) in bubblesSorted"
                        :class="{
                            GridItem: true,
                            Active: i === data.bubble,
                            NoBorderLeft: index % 4 !== 0,
                            NoBorderTop: index > 3,
                        }"
                        :key="i.id"
                        @click="selectBubble(i)"
                    >
                        <div class="Toolbar">
                            <span>{{ friendlyName(i.fileName) }}</span>
                        </div>
                        <div class="ImageWrapper">
                            <video v-if="getBubbleImage(i).split('.').pop().toLowerCase() === 'mp4'" autoplay loop>
                                <source :src="getBubbleImage(i)" type="video/mp4">
                                <span>Video not supported.</span>
                            </video>
                            <img v-else :src="getBubbleImage(i)" :alt="friendlyName(i.fileName)" />
                        </div>
                        <div class="Check">
                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="16.5" height="13.5" viewBox="0 0 16.5 13.5" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.038 2.741c.298-.305.462-.708.462-1.133 0-.43-.164-.833-.462-1.138a1.55 1.55 0 00-2.222 0L4.869 9.616 2.684 7.385a1.548 1.548 0 00-2.222 0A1.614 1.614 0 000 8.522c0 .429.164.832.462 1.133l3.293 3.365a1.55 1.55 0 002.222 0"/></svg>
                        </div>
                    </div>
                    <div class="GridFullLoading" v-if="uploading">
                        <ui-loading />
                    </div>
                </div>
            </ui-scrollbar>
        </template>
        <input
            type="file"
            ref="uploader"
            name="file"
            accept="*"
            style="display: none"
            @change="upload"
        />
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.Grid
    display flex
    justify-content flex-start
    align-items flex-start
    align-content flex-start
    flex-wrap wrap
    min-height 100%
    box-sizing border-box
    position relative
    .GridItem
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 25%
        position relative
        border 1px solid $cBorder
        box-sizing border-box
        padding 20px
        transition .3s all
        background rgba(255,255,255,.4)
        cursor: pointer;
        &.StudioButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/studio_wide.png)
            background-size contain
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
        &.UploadButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/upload_transparent.png)
            background-size 64px
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
            &.Error
                background-color $cError
        &.NoneButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/none_square.png)
            background-size cover
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
        &.NoBorderTop
            border-top none
        &.NoBorderLeft
            border-left none
        .Toolbar
            font-size 12px
            font-weight 600
            color $cPrimary
            align-self flex-start
            overflow hidden
            white-space nowrap
            max-width 100%
        .ImageWrapper
            overflow hidden
            height 110px
            display flex
            flex-direction column
            justify-content center
            align-items center
            img, video
                max-width 100%
                max-height 110px
            .GridItemErrorMessage
                display inline-block
                margin-top 20px
                font-weight 500
                font-size 12px
                text-align center
                transition .3s all
            .GridItemUploadImage
                width 100%
                height 100%
                max-width 32px
                max-height 32px
                fill: $cPrimary
                transition .3s all
        .Check
            position absolute
            opacity 0
            top 0
            left 0
            right 0
            bottom 0
            background rgba(255,255,255,.7)
            display flex
            align-items center
            justify-content center
            transition .3s all
            svg
                transform scale(2)
            path
                fill $cAccent
        .GridItemHint
            position absolute
            padding 20px
            background #fff
            border 2px solid $cBorder
            color $cPrimary
            font-size 12px
            font-weight 400
            transform: translate(-50%, -50%) scale(0);
            transition .3s all
            z-index 9999
            left: 50%;
            top: 100%;
            width: calc(100% - 40px);
            min-width 300px
        &:hover
            .GridItemHint
                transform: translate(-50%, 0) scale(1);
        &.Active
            background-color #fff
            transform scale(1.08)
            z-index 2
            border-color white
            box-shadow 0 40px 100px rgba(0,0,0,.2)
            .Check
                opacity 1
            img
                filter blur(3px)
            &.NoneButton
                border-color #C0BFD0
        &.Error
            .ImageWrapper
                .GridItemErrorMessage
                    color $cError
                .GridItemUploadImage
                    fill $cError
        &:hover:not(.DisableHover)
            background #fff
    .GridFullLoading
        position absolute
        width 100%
        height 100%
        top 0
        left 0
        background rgba(255,255,255,.4)
        display flex
        align-items center
        justify-content center
        z-index 10
    &.AltImageSize
        .GridItem .ImageWrapper
            height 235px
        .GridItem .ImageWrapper img
            max-height 235px
            max-width 95px

.StepBubbles .Scrollbar
    padding 40px 70px 150px 70px !important
    margin -40px -50px -150px -70px
    .ps__scrollbar-y-rail
        right 50px !important
        top 50px !important
</style>
